/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Property_Created_OnInputs */



/**
* | output |
* | --- |
* | "Created On" |
*
* @param {Explorer_Info_Property_Created_OnInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_property_created_on = /** @type {((inputs?: Explorer_Info_Property_Created_OnInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Property_Created_OnInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cree le")
	if (locale === "de") return /** @type {LocalizedString} */ ("Erstellt am")
	if (locale === "it") return /** @type {LocalizedString} */ ("Creato il")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создано в")
	if (locale === "es") return /** @type {LocalizedString} */ ("Creado el")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("创建于")
	if (locale === "ja") return /** @type {LocalizedString} */ ("作成日")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पर बनाया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Criado em")
	return /** @type {LocalizedString} */ ("Created On")
});